var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mt-4",attrs:{"color":"info","id":"hyperionUButton","href":"https://knowledge.seerist.com/welcome/","target":"_blank"},on:{"click":_vm.storeMetric}},[_vm._v("Seerist University ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }